import Glide from '@glidejs/glide';
import $ from 'jquery';

$(() => {
    if($('.js-glide').length > 0) {
        new Glide('.js-glide', {
            type: 'carousel',
            //startAt: 0,
            focusAt: 'center',
            perView: 3,
            breakpoints: {
                800: {
                    perView: 1
                }
            }
        }).mount();
    }
    //console.log($('.js-glide-single .glide__slides li').length);
    if($('.js-glide-single .glide__slides li').length > 0) {
        if($('.js-glide-single .glide__slides li').length > 0) {
            new Glide('.js-glide-single', {
                type: 'carousel',
                //startAt: 0,
                //focusAt: 'center',
                perView: 1,
            }).mount();
        }
    }
});